module.exports = __webpack_public_path__ + "img/header.8edea298.jpg";